import { render, staticRenderFns } from "./CragRouteDifficultyIcon.vue?vue&type=template&id=e8c4f2be"
import script from "./CragRouteDifficultyIcon.vue?vue&type=script&lang=js"
export * from "./CragRouteDifficultyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports